import { Box, Button, Flex, Text } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonText, Modal } from '@morressier/alembic';
import { faFile } from '@fortawesome/pro-regular-svg-icons';
import { openFile } from 'src/utils/file';
import { faArrowRotateLeft } from '@fortawesome/pro-light-svg-icons';
import { IGetSubmissionUnsubmitResponse } from '@publishing-engine/submission-service/src/endpoints/api.response-types';

interface Props {
  data: IGetSubmissionUnsubmitResponse;
  onClose: () => void;
}

export const UnsubmitContextModal = ({ onClose, data }: Props) => {
  const { attachments, editorComment } = data || {};

  return (
    <Modal
      isOpen
      closeButtonProps={{
        hidden: true
      }}
      onClose={onClose}
      width="720px"
    >
      <Flex
        padding={8}
        gap={6}
        flexDirection="column"
        maxHeight="80vh"
        overflow="auto"
      >
        <Box>
          <FontAwesomeIcon fontSize={32} icon={faArrowRotateLeft} />
        </Box>

        <Flex flexDirection="column" gap={2}>
          <Text textStyle="headingGroup">Unsubmit Context</Text>
        </Flex>

        <Flex gap={2} flexDirection="column">
          <Text textStyle="headingItem">Response to Author</Text>
          <Text textStyle="textBody">{editorComment}</Text>
        </Flex>

        {!!attachments?.length && (
          <Flex gap={2} flexDirection="column">
            <Text textStyle="headingItem">Attached Files</Text>
            <Flex flexDirection="column" marginTop={2} gap={2}>
              {attachments.map(attachment => (
                <Flex
                  justifyContent="space-between"
                  key={attachment.referenceName}
                >
                  <Flex gap={2} alignItems="center">
                    <FontAwesomeIcon icon={faFile} />
                    <Text textStyle="textBody">{attachment.referenceName}</Text>
                    <ButtonText onClick={() => openFile(attachment.url)}>
                      View
                    </ButtonText>
                  </Flex>
                </Flex>
              ))}
            </Flex>
          </Flex>
        )}

        <Flex
          gap={2}
          justifyContent="flex-end"
          alignItems="center"
          alignSelf="stretch"
        >
          <Button onClick={onClose} variant="primary" borderRadius="small">
            Close
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};
